export default __webpack_public_path__ + "static/media/wa.5c4c30e8.jpg";